export const environment = {
  apiUrl: "https://api2dev.eyelation.com/api",
  //defaultRedirectUri: "https://deveyeonline.eyelation.com",
  defaultRedirectUri: "https://weborder.dev.eyelation.com",
  //adminRedirectUri: "https://devadmin.eyelation.com/",
  adminRedirectUri: "https://admin.dev.eyelation.com",
  environmentName: "Development",
  production: false,
  supportEmail: "questions@eyelation.com",
  workosClientId: "client_01JQ4DB4TFDP1BSSTTCQC2ZHPJ",
  workosUrl: "https://significant-strength-91-staging.authkit.app",
};
